import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { BRAND_NAME } from 'src/components'
import { paths } from 'src/router'

import { useStyles } from './styles'

const { Link: AntdLink } = Typography

/**
 * The footer the signed-out screens wear, trimmed to the two legal links.
 *
 * No language picker: by the time somebody is creating a workspace they have an
 * account, and the language belongs to it — profile settings own that choice.
 *
 * Deliberately not `AppFooter`, which belongs to the product — version, service
 * status, docs and changelog are answers to questions somebody in the middle of
 * creating their first workspace has not asked yet. The same pair of links sits
 * under the sign-in form (`LayoutAuth`), and this keeps the first-run flow
 * looking like a continuation of it rather than like the app it is not in yet.
 */
export const PublicChromeFooter = () => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  return (
    <Flex
      align="center"
      gap={16}
      wrap="wrap"
      className={styles.publicFooter}
      component="footer"
    >
      <Flex align="center" gap={16} wrap="wrap">
        <AntdLink href={paths.termsAndConditions} type="secondary">
          {t('terms_and_conditions')}
        </AntdLink>
        <AntdLink
          href={`mailto:support@skalx.ai?subject=${encodeURIComponent(`${BRAND_NAME} Help`)}`}
          type="secondary"
        >
          {t('contact_us')}
        </AntdLink>
      </Flex>
    </Flex>
  )
}
